import React, { Component } from "react";

import FormField from "../ui/FormFields";
import { validate } from "../ui/misc";

import FileUploader from "../ui/Fileuploader";

import Button from "@material-ui/core/Button";

import { firebase, FirebaseProducts } from "../../firebase";

import { Helmet } from "react-helmet";

class AddProduct extends Component {
  state = {
    selected: "",
    productId: "",
    formType: "Добавить",
    formError: false,
    formSuccess: "",
    defaultImg: "",
    formData: {
      product: {
        element: "input",
        value: this.props.match.params.id,
        config: {
          label: "Продукт",
          name: "prodcuct_input",
          type: "text",
          placeholder: "Продукт"
        },
        validation: {
          required: true
        },
        valid: false,
        validationMessage: "",
        showLabel: false
      },
      title: {
        element: "input",
        value: "",
        config: {
          label: "Название продукта",
          name: "title_input",
          type: "text",
          placeholder: "Название продукта"
        },
        validation: {
          required: true
        },
        valid: false,
        validationMessage: "",
        showLabel: false
      },
      type: {
        element: "select",
        value: "",
        config: {
          label: "Тип продукта",
          name: "select_type",
          type: "select",
          placeholder: "Тип продукта",
          options: [
            { key: "Карповые", value: "Карповые" },
            { key: "Фидерные", value: "Фидерные" },
            { key: "Телескопические", value: "Телескопические" },
            { key: "Спиннинговые", value: "Спиннинговые" },
            { key: "Болонские", value: "Болонские" },
            { key: "Джокерные", value: "Джокерные" },
            { key: "Макухи", value: "Макухи" },
            { key: "Ароматизаторы", value: "Ароматизаторы" },
            { key: "Пластелин", value: "Пластелин" },
            { key: "Клей Рыбаловный", value: "Клей Рыбаловный" },
            { key: "Черви", value: "Черви" },
            { key: "Опарыши", value: "Опарыши" },
            { key: "Мотыли", value: "Мотыли" },
            { key: "Кукуруза", value: "Кукуруза" },
            { key: "Воздушное тесто", value: "Воздушное тесто" },
            { key: "Бойлы", value: "Бойлы" },
            { key: "Мамалыга", value: "Мамалыга" },
            { key: "Пеллетс", value: "Пеллетс" },
            { key: "Технопуф", value: "Технопуф" },
            { key: "Блёсна", value: "Блёсна" },
            { key: "Воблеры", value: "Воблеры" },
            { key: "Cиликоны", value: "Cиликоны" },
            { key: "Вертушки", value: "Вертушки" },
            { key: "Подставки", value: "Подставки" },
            { key: "Родподы", value: "Родподы" },
            { key: "Подсаки", value: "Подсаки" },
            { key: "Раколовки", value: "Раколовки" },
            { key: "Садки", value: "Садки" },
            { key: "Чехлы", value: "Чехлы" },
            { key: "Сумки", value: "Сумки" },
            { key: "Рюкзаки", value: "Рюкзаки" },
            { key: "Жилеты", value: "Жилеты" },
            { key: "Костюмы", value: "Костюмы" },
            { key: "Накидки от комаров", value: "Накидки от комаров" },
            { key: "Плащи", value: "Плащи" },
            { key: "Шорты", value: "Шорты" },
            { key: "Кресла", value: "Кресла" },
            { key: "Стулья", value: "Стулья" },
            { key: "Палатки", value: "Палатки" },
            { key: "Разное", value: "Разное" },
            { key: "Безинерционные", value: "Безинерционные" },
            { key: "с Бейтранером", value: "с Бейтранером" },
            { key: "Инерционные", value: "Инерционные" },
            { key: "Инерционнаые", value: "Инерционнаые" },
            { key: "Готовый монтаж", value: "Готовый монтаж" },
            { key: "Крючки", value: "Крючки" },
            { key: "Вертлюги", value: "Вертлюги" },
            { key: "Карабины", value: "Карабины" },
            { key: "Поплавки", value: "Поплавки" },
            { key: "Резинки", value: "Резинки" },
            { key: "Грузы", value: "Грузы" },
            { key: "Кормушки", value: "Кормушки" },
            { key: "Лески", value: "Лески" },
            { key: "Отводы", value: "Отводы" },
            { key: "Сигнализаторы", value: "Сигнализаторы" },
            { key: "Свингеры", value: "Свингеры" },
            { key: "Вкусные приманки", value: "Вкусные приманки" }
          ]
        },
        validation: {
          required: true
        },
        valid: false,
        validationMessage: "",
        showLabel: false
      },
      brand: {
        element: "input",
        value: "",
        config: {
          label: "Производитель",
          name: "brand_input",
          type: "text",
          placeholder: "Производитель"
        },
        validation: {
          required: true
        },
        valid: false,
        validationMessage: "",
        showLabel: false
      },
      model: {
        element: "input",
        value: "",
        config: {
          label: "Модель",
          name: "model_input",
          type: "text",
          placeholder: "Модель"
        },
        validation: {
          required: true
        },
        valid: false,
        validationMessage: "",
        showLabel: false
      },
      desc: {
        element: "textarea",
        value: "",
        config: {
          label: "Описание",
          name: "desc_textarea",
          type: "textarea",
          placeholder: "Описание"
        },
        validation: {
          required: true
        },
        valid: false,
        validationMessage: "",
        showLabel: false
      },
      isInStore: {
        element: "select",
        value: "",
        config: {
          label: "Есть в наличии?",
          name: "select_isInStore",
          type: "select",
          options: [{ key: "Да", value: "Да" }, { key: "Нет", value: "Нет" }]
        },
        validation: {
          required: true
        },
        valid: false,
        validationMessage: "",
        showLabel: true
      },
      construct: {
        element: "input",
        value: "",
        config: {
          label: "Конструкция",
          name: "construct_input",
          type: "text",
          placeholder: "Конструкция"
        },
        validation: {
          required: true
        },
        valid: false,
        validationMessage: "",
        showLabel: false
      },
      handle: {
        element: "input",
        value: "",
        config: {
          label: "Рукоять",
          name: "handle_input",
          type: "text",
          placeholder: "Рукоять"
        },
        validation: {
          required: true
        },
        valid: false,
        validationMessage: "",
        showLabel: false
      },
      length: {
        element: "input",
        value: "",
        config: {
          label: "Длина",
          name: "number_length",
          type: "number",
          placeholder: "Длина"
        },
        validation: {
          required: true
        },
        valid: false,
        validationMessage: "",
        showLabel: false
      },
      material: {
        element: "input",
        value: "",
        config: {
          label: "Матерьял",
          name: "material_input",
          type: "text",
          placeholder: "Матерьял"
        },
        validation: {
          required: true
        },
        valid: false,
        validationMessage: "",
        showLabel: false
      },
      rings: {
        element: "input",
        value: "",
        config: {
          label: "Кольца",
          name: "rings_input",
          type: "text",
          placeholder: "Кольца"
        },
        validation: {
          required: true
        },
        valid: false,
        validationMessage: "",
        showLabel: false
      },
      test: {
        element: "input",
        value: "",
        config: {
          label: "Тест",
          name: "number_test",
          type: "number",
          placeholder: "Тест"
        },
        validation: {
          required: true
        },
        valid: false,
        validationMessage: "",
        showLabel: false
      },
      DiameterOfSpool: {
        element: "input",
        value: "",
        config: {
          label: "Диаметр шпули",
          name: "number_DiameterOfSpool",
          type: "number",
          placeholder: "Диаметр шпули"
        },
        validation: {
          required: true
        },
        valid: false,
        validationMessage: "",
        showLabel: false
      },
      Lesoyemkost: {
        element: "input",
        value: "",
        config: {
          label: "Лесоёмкость",
          name: "Lesoyemkost_input",
          type: "text",
          placeholder: "Лесоёмкость"
        },
        validation: {
          required: true
        },
        valid: false,
        validationMessage: "",
        showLabel: false
      },
      friction: {
        element: "input",
        value: "",
        config: {
          label: "Фрикцион",
          name: "friction_input",
          type: "text",
          placeholder: "Фрикцион"
        },
        validation: {
          required: true
        },
        valid: false,
        validationMessage: "",
        showLabel: false
      },
      gearRatio: {
        element: "input",
        value: "",
        config: {
          label: "Передаточное число",
          name: "gearRatio_input",
          type: "text",
          placeholder: "Передаточное число"
        },
        validation: {
          required: true
        },
        valid: false,
        validationMessage: "",
        showLabel: false
      },
      numBearing: {
        element: "input",
        value: "",
        config: {
          label: "Количество подшипников",
          name: "number_numBearing",
          type: "number",
          placeholder: "Количество подшипников"
        },
        validation: {
          required: true
        },
        valid: false,
        validationMessage: "",
        showLabel: false
      },
      numSpots: {
        element: "input",
        value: "",
        config: {
          label: "Количество подшипников",
          name: "number_numSpots",
          type: "number",
          placeholder: "Количество подшипников"
        },
        validation: {
          required: true
        },
        valid: false,
        validationMessage: "",
        showLabel: false
      },
      weight: {
        element: "input",
        value: "",
        config: {
          label: "Вес",
          name: "number_weight",
          type: "number",
          placeholder: "Вес"
        },
        validation: {
          required: true
        },
        valid: false,
        validationMessage: "",
        showLabel: false
      },
      quant: {
        element: "input",
        value: "",
        config: {
          label: "Количество",
          name: "number_quant",
          type: "number",
          placeholder: "Количество"
        },
        validation: {
          required: true
        },
        valid: false,
        validationMessage: "",
        showLabel: false
      },
      Wobblerlength: {
        element: "input",
        value: "",
        config: {
          label: "Длина воблера",
          name: "number_Wobblerlength",
          type: "number",
          placeholder: "Длина воблера"
        },
        validation: {
          required: true
        },
        valid: false,
        validationMessage: "",
        showLabel: false
      },
      DeepeningOfWobbler: {
        element: "input",
        value: "",
        config: {
          label: "Заглубление воблера",
          name: "number_DeepeningOfWobbler",
          type: "text",
          placeholder: "Заглубление воблера"
        },
        validation: {
          required: true
        },
        valid: false,
        validationMessage: "",
        showLabel: false
      },
      height: {
        element: "input",
        value: "",
        config: {
          label: "Высота",
          name: "number_height",
          type: "number",
          placeholder: "Высота"
        },
        validation: {
          required: true
        },
        valid: false,
        validationMessage: "",
        showLabel: false
      },
      width: {
        element: "input",
        value: "",
        config: {
          label: "Ширина",
          name: "number_width",
          type: "number",
          placeholder: "Ширина"
        },
        validation: {
          required: true
        },
        valid: false,
        validationMessage: "",
        showLabel: false
      },
      numBranches: {
        element: "input",
        value: "",
        config: {
          label: "Количество отводов",
          name: "number_numBranches",
          type: "number",
          placeholder: "Количество отводов"
        },
        validation: {
          required: true
        },
        valid: false,
        validationMessage: "",
        showLabel: false
      },
      diameter: {
        element: "input",
        value: "",
        config: {
          label: "Диаметр",
          name: "number_diamete",
          type: "number",
          placeholder: "Диаметр"
        },
        validation: {
          required: true
        },
        valid: false,
        validationMessage: "",
        showLabel: false
      },
      handleLength: {
        element: "input",
        value: "",
        config: {
          label: "Длина рукояти",
          name: "number_handleLength",
          type: "number",
          placeholder: "Длина рукояти"
        },
        validation: {
          required: true
        },
        valid: false,
        validationMessage: "",
        showLabel: false
      },
      SizeOfCell: {
        element: "input",
        value: "",
        config: {
          label: "Размер ячейки",
          name: "number_SizeOfCell",
          type: "number",
          placeholder: "Размер ячейки"
        },
        validation: {
          required: true
        },
        valid: false,
        validationMessage: "",
        showLabel: false
      },
      diameterRing: {
        element: "input",
        value: "",
        config: {
          label: "Диаметр кольца",
          name: "number_diameterRing",
          type: "number",
          placeholder: "Диаметр кольца"
        },
        validation: {
          required: true
        },
        valid: false,
        validationMessage: "",
        showLabel: false
      },
      numRings: {
        element: "input",
        value: "",
        config: {
          label: "Количество колец",
          name: "number_numRings",
          type: "number",
          placeholder: "Количество колец"
        },
        validation: {
          required: true
        },
        valid: false,
        validationMessage: "",
        showLabel: false
      },
      NumOfPockets: {
        element: "input",
        value: "",
        config: {
          label: "Количество корманов",
          name: "number_NumOfPockets",
          type: "number",
          placeholder: "Количество корманов"
        },
        validation: {
          required: true
        },
        valid: false,
        validationMessage: "",
        showLabel: false
      },
      NumOfSeparations: {
        element: "input",
        value: "",
        config: {
          label: "Количество отсеков",
          name: "number_NumOfSeparations",
          type: "number",
          placeholder: "Количество отсеков"
        },
        validation: {
          required: true
        },
        valid: false,
        validationMessage: "",
        showLabel: false
      },
      depth: {
        element: "input",
        value: "",
        config: {
          label: "Глубина",
          name: "number_depth",
          type: "number",
          placeholder: "Глубина"
        },
        validation: {
          required: true
        },
        valid: false,
        validationMessage: "",
        showLabel: false
      },
      sizeAvailable: {
        element: "input",
        value: "",
        config: {
          label: "Размеры",
          name: "number_depth",
          type: "select",
          placeholder: "Размеры"
        },
        validation: {
          required: true
        },
        valid: false,
        validationMessage: "",
        showLabel: false
      },
      price: {
        element: "input",
        value: "",
        config: {
          label: "Цена",
          name: "number_price",
          type: "number",
          placeholder: "Цена"
        },
        validation: {
          required: true
        },
        valid: false,
        validationMessage: "",
        showLabel: false
      },
      image: {
        element: "image",
        value: "",
        validation: {
          required: true
        },
        valid: false
      }
    }
  };

  updateForm(element, content = "") {
    const newFormData = { ...this.state.formData };
    const newElement = { ...newFormData[element.id] };
    if (content === "") {
      newElement.value = element.event.target.value;
    } else {
      newElement.value = content;
    }

    let validData = validate(newElement);

    newElement.valid = validData[0];
    newElement.validationMessage = validData[1];

    newFormData[element.id] = newElement;

    this.setState({
      formError: false,
      formData: newFormData
    });
  }

  submitForm(event) {
    event.preventDefault();

    let dataToSubmit = {};
    let formIsValid = true;

    for (let key in this.state.formData) {
      dataToSubmit[key] = this.state.formData[key].value;
      formIsValid = this.state.formData[key].valid && formIsValid;
    }

    FirebaseProducts.push(dataToSubmit)
      .then(() => {
        this.props.history.push("/products/Продукты");
      })
      .catch(e => {
        this.setState({
          formError: true
        });
      });
  }
  storeFileName = fileName => {
    this.updateForm({ id: "image" }, fileName);
  };

  resetImage = () => {
    const newFormData = { ...this.state.formData };

    firebase
      .storage()
      .ref(`product`)
      .child(newFormData["image"].value)
      .delete()
      .then(console.log("deleted from db"));

    newFormData["image"].value = "";
    newFormData["image"].valid = false;

    this.setState({
      defaultImg: "",
      formData: newFormData
    });
  };

  render() {
    const product = this.props.match.params.id;
    return (
      <div id="product" style={{
        backgroundColor: 'floralwhite'
      }}>
      <Helmet>
        <meta charSet="utf-8" />
        <meta name="robots" content="noindex" />
        <link rel="shortcut icon" type="image/png" href="/public/Icon.png" />
        <title>Планета Рыбака - Добавить Продукт</title>
        <link rel="canonical" href={`http://rybalka.md.com/${product}/add`} />
        <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
        <meta
          name="description"
          content="Магазин рыболовных изделий в Молдове, Кишинёв, улица Alba-Iulia 198 ger.34/1, рынок 'Дельфин'. Тут вы найдёте удилища, кутушки, снасти, прикормки, наживки, приманки, подставки, подсаки, сумки, одежда, снаряжения и другое, всё для рыбалки."
        />
        <meta
          property="og:url"
          content={`http://rybalka.md.com/${product}/add`}
        />
      </Helmet>
        <div className="container">
          <div className="wrapper">
            <div className="item">
              <form onSubmit={event => this.submitForm(event)}>
                <div className="item_top">
                  <div className="item_image" style={{
                    flexBasis: '60%'
                  }}>
                    <FileUploader
                      dir={`product`}
                      tag={"Фото продукта"}
                      defaultImage={this.state.defaultImg}
                      defaultImageName={this.state.formData.image.value}
                      resetImg={() => this.resetImage()}
                      fileName={fileName => this.storeFileName(fileName)}
                    />
                  </div>
                  <div className="desription">
                    <div className="item_title">
                      <FormField
                        id={"title"}
                        formData={this.state.formData.title}
                        change={element => this.updateForm(element)}
                      />
                    </div>

                    <div className="item_type">
                      <FormField
                        id={"type"}
                        formData={this.state.formData.type}
                        change={element => this.updateForm(element)}
                      />
                    </div>

                    <div className="item_brand">
                      <FormField
                        id={"brand"}
                        formData={this.state.formData.brand}
                        change={element => this.updateForm(element)}
                      />
                    </div>

                    <div className="item_model">
                      <FormField
                        id={"model"}
                        formData={this.state.formData.model}
                        change={element => this.updateForm(element)}
                      />
                    </div>

                    <div className="item_desc">
                      <FormField
                        id={"desc"}
                        formData={this.state.formData.desc}
                        change={element => this.updateForm(element)}
                      />
                    </div>
                    <div className="item_isInStore">
                      <FormField
                        id={"isInStore"}
                        formData={this.state.formData.isInStore}
                        change={element => this.updateForm(element)}
                      />
                    </div>
                    <div className="item_price">
                      <FormField
                        id={"price"}
                        formData={this.state.formData.price}
                        change={element => this.updateForm(element)}
                      />
                    </div>
                  </div>
                </div>

                <div className="item_bottom">
                  <div className="divider">
                    <hr className="left" />
                    <span className="item_bottom_title">Характеристики</span>
                    <hr className="right" />
                  </div>

                  <div className="characteristics">
                    <div className="item_characteristic">
                      <React.Fragment>
                        {product === "Удилища" ? (
                          <React.Fragment>
                            <FormField
                              id={"construct"}
                              formData={this.state.formData.construct}
                              change={element => this.updateForm(element)}
                            />
                            <FormField
                              id={"handle"}
                              formData={this.state.formData.handle}
                              change={element => this.updateForm(element)}
                            />
                            <FormField
                              id={"length"}
                              formData={this.state.formData.length}
                              change={element => this.updateForm(element)}
                            />
                            <FormField
                              id={"material"}
                              formData={this.state.formData.material}
                              change={element => this.updateForm(element)}
                            />
                            <FormField
                              id={"rings"}
                              formData={this.state.formData.rings}
                              change={element => this.updateForm(element)}
                            />
                            <FormField
                              id={"test"}
                              formData={this.state.formData.test}
                              change={element => this.updateForm(element)}
                            />
                          </React.Fragment>
                        ) : null}

                        {product === "Катушки" ? (
                          <React.Fragment>
                            <FormField
                              id={"DiameterOfSpool"}
                              formData={this.state.formData.DiameterOfSpool}
                              change={element => this.updateForm(element)}
                            />
                            <FormField
                              id={"Lesoyemkost"}
                              formData={this.state.formData.Lesoyemkost}
                              change={element => this.updateForm(element)}
                            />
                            <FormField
                              id={"friction"}
                              formData={this.state.formData.friction}
                              change={element => this.updateForm(element)}
                            />
                            <FormField
                              id={"gearRatio"}
                              formData={this.state.formData.gearRatio}
                              change={element => this.updateForm(element)}
                            />
                            <FormField
                              id={"numBearing"}
                              formData={this.state.formData.numBearing}
                              change={element => this.updateForm(element)}
                            />
                            <FormField
                              id={"weight"}
                              formData={this.state.formData.weight}
                              change={element => this.updateForm(element)}
                            />
                          </React.Fragment>
                        ) : null}

                        {product === "Прикормка" ? (
                          <React.Fragment>
                            <FormField
                              id={"quant"}
                              formData={this.state.formData.quant}
                              change={element => this.updateForm(element)}
                            />
                            <FormField
                              id={"weight"}
                              formData={this.state.formData.weight}
                              change={element => this.updateForm(element)}
                            />
                          </React.Fragment>
                        ) : null}

                        {product === "Наживки" ? (
                          <React.Fragment>
                            <FormField
                              id={"quant"}
                              formData={this.state.formData.quant}
                              change={element => this.updateForm(element)}
                            />
                            <FormField
                              id={"weight"}
                              formData={this.state.formData.weight}
                              change={element => this.updateForm(element)}
                            />
                          </React.Fragment>
                        ) : null}

                        {product === "Приманки" ? (
                          <React.Fragment>
                            <FormField
                              id={"length"}
                              formData={this.state.formData.length}
                              change={element => this.updateForm(element)}
                            />
                            <FormField
                              id={"quant"}
                              formData={this.state.formData.quant}
                              change={element => this.updateForm(element)}
                            />
                            <FormField
                              id={"weight"}
                              formData={this.state.formData.weight}
                              change={element => this.updateForm(element)}
                            />

                            {this.state.formData.type.value === "Воблеры" ? (
                              <React.Fragment>
                                <FormField
                                  id={"DeepeningOfWobbler"}
                                  formData={
                                    this.state.formData.DeepeningOfWobbler
                                  }
                                  change={element => this.updateForm(element)}
                                />
                                <FormField
                                  id={"Wobblerlength"}
                                  formData={this.state.formData.Wobblerlength}
                                  change={element => this.updateForm(element)}
                                />
                              </React.Fragment>
                            ) : null}
                          </React.Fragment>
                        ) : null}

                        {product === "Подставки" ? (
                          <React.Fragment>
                            <FormField
                              id={"construct"}
                              formData={this.state.formData.construct}
                              change={element => this.updateForm(element)}
                            />
                            <FormField
                              id={"height"}
                              formData={this.state.formData.height}
                              change={element => this.updateForm(element)}
                            />
                            <FormField
                              id={"width"}
                              formData={this.state.formData.width}
                              change={element => this.updateForm(element)}
                            />
                            <FormField
                              id={"length"}
                              formData={this.state.formData.length}
                              change={element => this.updateForm(element)}
                            />
                            <FormField
                              id={"material"}
                              formData={this.state.formData.material}
                              change={element => this.updateForm(element)}
                            />
                          </React.Fragment>
                        ) : null}

                        {product === "Подсаки" ? (
                          <React.Fragment>
                            {this.state.formData.type.value === "Подсаки" ? (
                              <React.Fragment>
                                <FormField
                                  id={"diameter"}
                                  formData={this.state.formData.diameter}
                                  change={element => this.updateForm(element)}
                                />
                                <FormField
                                  id={"handleLength"}
                                  formData={this.state.formData.handleLength}
                                  change={element => this.updateForm(element)}
                                />
                              </React.Fragment>
                            ) : null}

                            {this.state.formData.type.value === "Раколовки" ? (
                              <FormField
                                id={"numBranches"}
                                formData={this.state.formData.numBranches}
                                change={element => this.updateForm(element)}
                              />
                            ) : null}

                            {this.state.formData.type.value === "Садки" ? (
                              <React.Fragment>
                                <FormField
                                  id={"length"}
                                  formData={this.state.formData.length}
                                  change={element => this.updateForm(element)}
                                />
                                <FormField
                                  id={"numRings"}
                                  formData={this.state.formData.numRings}
                                  change={element => this.updateForm(element)}
                                />
                                <FormField
                                  id={"diameterRing"}
                                  formData={this.state.formData.diameterRing}
                                  change={element => this.updateForm(element)}
                                />
                                <FormField
                                  id={"SizeOfCell"}
                                  formData={this.state.formData.SizeOfCell}
                                  change={element => this.updateForm(element)}
                                />
                              </React.Fragment>
                            ) : null}
                          </React.Fragment>
                        ) : null}

                        {product === "Сумки" ? (
                          <React.Fragment>
                            <FormField
                              id={"NumOfPockets"}
                              formData={this.state.formData.NumOfPockets}
                              change={element => this.updateForm(element)}
                            />
                            <FormField
                              id={"NumOfSeparations"}
                              formData={this.state.formData.NumOfSeparations}
                              change={element => this.updateForm(element)}
                            />
                            <FormField
                              id={"depth"}
                              formData={this.state.formData.depth}
                              change={element => this.updateForm(element)}
                            />
                            <FormField
                              id={"height"}
                              formData={this.state.formData.height}
                              change={element => this.updateForm(element)}
                            />
                            <FormField
                              id={"width"}
                              formData={this.state.formData.width}
                              change={element => this.updateForm(element)}
                            />
                          </React.Fragment>
                        ) : null}

                        {product === "Одежда" ? (
                          <React.Fragment>
                            <FormField
                              id={"sizeAvailable"}
                              formData={this.state.formData.sizeAvailable}
                              change={element => this.updateForm(element)}
                            />
                          </React.Fragment>
                        ) : null}

                        {product === "Снаряжение" &&
                        this.state.formData.type.value === "Палатки" ? (
                          <React.Fragment>
                            <FormField
                              id={"numSpots"}
                              formData={this.state.formData.numSpots}
                              change={element => this.updateForm(element)}
                            />
                          </React.Fragment>
                        ) : null}
                      </React.Fragment>
                    </div>
                  </div>

                  <hr className="hr-divider" />
                </div>

                <div className="success_label">{this.state.formSuccess}</div>
                {this.state.formError ? (
                  <div className="error_label">Что-то пошло не так</div>
                ) : (
                  ""
                )}

                <div
                  className="admin_submit"
                  style={{
                    display: "flex",
                    justifyContent: "center"
                  }}
                >
                  <Button
                    style={{
                      backgroundColor: "#005f9c"
                    }}
                    variant="contained"
                    color="primary"
                    onClick={event => this.submitForm(event)}
                  >
                    {this.state.formType}
                  </Button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AddProduct;
